import classNames from 'class-names';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import {
  Form,
  FormControl,
  InputGroup,
  Overlay,
  Tooltip,
} from 'react-bootstrap';

const InputGroupText = ({
  label = null,
  helpText,
  children,
  groupClassName,
  labelClassName,
  errorDisplayMode = 'inline',
  errorTooltipPlacement = 'top',
  groupText = '',
  groupTextPosition = 'append',
  ...props
}) => {
  const tooltipOverlayTarget = useRef(null);
  const [field, { touched, error }] = useField(props);
  const isInvalid = touched && error;
  const overlay = isInvalid && errorDisplayMode === 'tooltip';

  return (
    <>
      {!!label && <Form.Label className={labelClassName}>{label}</Form.Label>}
      <InputGroup controlid={field.name} className={groupClassName}>
        {groupText && groupTextPosition === 'prepend' && (
          <InputGroup.Prepend>
            <InputGroup.Text
              className={classNames('bg-white', {
                'text-danger border-danger': isInvalid,
              })}
            >
              {groupText}
            </InputGroup.Text>
          </InputGroup.Prepend>
        )}
        <FormControl
          {...field}
          {...props}
          isInvalid={isInvalid}
          ref={tooltipOverlayTarget}
          className={classNames({
            'border-right-0': groupText && groupTextPosition === 'append',
          })}
        >
          {children}
        </FormControl>

        {groupText && groupTextPosition === 'append' && (
          <InputGroup.Append>
            <InputGroup.Text
              className={classNames('bg-white', {
                'text-danger border-danger': isInvalid,
              })}
            >
              {groupText}
            </InputGroup.Text>
          </InputGroup.Append>
        )}

        <Overlay
          target={tooltipOverlayTarget.current}
          show={overlay}
          placement={errorTooltipPlacement}
        >
          <Tooltip className="tooltip-red">{error}</Tooltip>
        </Overlay>

        {isInvalid && errorDisplayMode === 'inline' && (
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        )}

        {helpText && (!isInvalid || overlay) && (
          <Form.Text muted className="w-100">
            {helpText}
          </Form.Text>
        )}
      </InputGroup>
    </>
  );
};

InputGroupText.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  helpText: PropTypes.string,
  groupClassName: PropTypes.string,
  groupText: PropTypes.string,
  groupTextPosition: PropTypes.oneOf(['append', 'prepend']),
  labelClassName: PropTypes.string,
  children: PropTypes.node,
  errorDisplayMode: PropTypes.oneOf(['inline', 'tooltip']),
  errorTooltipPlacement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
};

export default InputGroupText;
